export const configFetched = (config) => ({
  type: "FETCH_CONFIG_SUCCESS",
  config,
});

export const registerFetched = (register) => ({
  type: "FETCH_REGISTER_SUCCESS",
  register,
});
